module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter3",
    attrs: {
      "id": "toc-preface002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface002"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("1. The Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Battle of Cunaxa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Xenophon Takes Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Kurdestan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Discipline Breaks Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Back to Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Last Adventure")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0